<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="tskInfoCode"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 5"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true, trigger: 'row' }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:taskNo="{ row }">
        <div>
          {{ row.tskInfoNo }}
        </div>
        <div class="mt-2 d-flex flex-row">
          <div class="d-flex align-items-center flex-grow-1">
            <div class="icon-task-type mr-2">
              <img :src="row.iconUrl" />
            </div>
            <div class="level-tag">
              <el-tag size="mini" effect="dark" :type="row.tskImportantLevel">
                {{ row.v_tskImportantLevel }}
              </el-tag>
            </div>
          </div>
          <div
            class="mark-btn"
            :class="{ 'mark-star': row.isMark == 'Y' }"
            @click.stop="markTsk(row)"
          >
            <span class="star">
              <b-icon-star></b-icon-star>
            </span>
            <span class="star-fill">
              <b-icon-star-fill></b-icon-star-fill>
            </span>
          </div>
        </div>
      </template>
      <template v-slot:taskTitle="{ row }">
        <div>
          <div class="mb-1">
            <div class="task-cust-icon inline-block mr-2">
              <img :src="vipIcon" />
            </div>
            <div class="inline-block">{{ row.custName }}</div>
          </div>
          <div class="text-truncate">
            <TskText :content="row.tskOverview">
              <el-link
                :ref="'link'"
                v-if="row.tskOverview"
                :underline="false"
                type="primary"
                @click.stop="
                  openEditPage({
                    pageType: 'detail',
                    params: { code: row.tskInfoCode },
                    query: { tskInfoNo: row.tskInfoNo },
                  })
                "
              >
                {{ row.tskOverview }}
              </el-link>
            </TskText>
          </div>
        </div>
      </template>
      <template v-slot:taskStatus="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="
              row.tskStatus == 'N'
                ? 'info'
                : row.tskStatus == 'P'
                ? ''
                : row.tskStatus == 'U'
                ? 'warning'
                : row.tskStatus == 'C'
                ? 'success'
                : row.tskStatus == 'Y'
                ? 'success'
                : 'danger'
            "
          >
            {{ row.v_tskStatus }}
          </el-tag>
        </div>
      </template>
      <template v-slot:tskEndDate="{ row }">
        <div>
          {{ row.tskEndDate }}
        </div>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import TskText from './tsk-text.vue'
const vipIcon = require('../images/vip_line@3x.png')
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TskText },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      vipIcon,
      isShowTooltip: false,
    }
  },
  computed: {},
  methods: {
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'personal-taskCenter-detail',
        params: { ...params, pageType },
        query,
      })
    },
    markTsk({ tskInfoCode, isMark }) {
      if (isMark == 'Y') {
        this.delMarkTsk({ tskInfoCode })
      } else {
        this.$emit('markTsk', [tskInfoCode])
      }
    },
    async delMarkTsk({ tskInfoCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_delMarkTsk') || '是否取消重点标记？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .personalTskMarkDelApi({ listTskInfoCode: [tskInfoCode] })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_delMarkTsk_no') || '取消失败！')
        return
      }
      this.$message({
        message: this.$l('tips_delMarkTsk_ok') || '取消成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    padding-top: 4px;
    margin-bottom: 14px;
  }
}
.inline-block {
  display: inline-block;
}
.task-cust-icon {
  width: 18px;
  height: 18px;
  > img {
    width: 18px;
    height: 18px;
  }
}
.icon-task-type {
  width: 20px;
  height: 18px;
  display: flex;
  > img {
    width: 20px;
    height: 18px;
  }
}
::v-deep {
  .el-tag--High {
    color: white;
    background-color: #fa5c7c;
    border: none;
  }
  .el-tag--Medium {
    color: white;
    background-color: #6c757d;
    border: none;
  }
  .el-tag--Low {
    color: white;
    background-color: #13cf97;
    border: none;
  }
  .el-tag--Y {
    color: #fa561f;
    background-color: #fff2e8;
    border-color: rgba($color: #fa561f, $alpha: 0.6);
  }
  .el-link {
    vertical-align: bottom;
  }
}
::v-deep {
  .el-link {
    display: inline;
  }
}

.mark-btn {
  font-size: 20px;
  cursor: pointer;
  .star-fill {
    display: none;
  }
}
.mark-btn.mark-star {
  color: #e99d42;
  .star {
    display: none;
  }
  .star-fill {
    display: block;
  }
}
.mark-btn:hover {
  color: #e99d42;
  .star {
    display: none;
  }
  .star-fill {
    display: block;
  }
}
</style>
